import MuiIconButton, { type IconButtonProps } from '@mui/material/IconButton'
import { type FC, type ReactNode } from 'react'

import Tooltip from '@/app/component/atom/tooltip'

type Props = IconButtonProps & {
  tooltip?: ReactNode
}

const IconButton: FC<Props> = (props) => {
  const { tooltip, ...iconButtonProps } = props

  return (
    <Tooltip title={tooltip}>
      <span>
        <MuiIconButton {...iconButtonProps} />
      </span>
    </Tooltip>
  )
}

export default IconButton
